/** Used as initiateSource / deal_type for payment and analytics. */
export enum INITIATE_SOURCE {
  REGULAR = 'promotion_plan_regular',
  RENEWAL = 'promotion_plan_renewal',
  TRIAL = 'promotion_plan_trial',
  FIRST_TIME = 'promotion_plan_first_time',
}
